<template>
</template>

<script>
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    import { Zoom } from 'ol/control';

    export default {
        mixins: [
            ButtonControlMixin
        ],
        props: {
            zoomInTipLabel: {
                type: String,
                default: 'Zoom in'
            },
            zoomOutTipLabel: {
                type: String,
                default: 'Zoom out'
            },
            asGroup: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                idPanel: 'zoom',
                className: 'ol-customzoom',
                classNameGroup: 'btn-group',
            }
        },
        computed: {
            orderClassName() {
                let group = this.asGroup ? this.classNameGroup : '';
                return `order-${this.idxBtnMap} ${this.className} ${group}`;
            }
        },
        methods:
        {
            addButtonMap: function(_map){
                // Zoom
                const zoomInLabel = document.createElement("label");
                zoomInLabel.setAttribute("class", "btn");
                let _img = document.createElement('img');
                _img.setAttribute('src', this.assetsPathTheme('/map/zoom-plus.svg'));
                _img.setAttribute('alt', this.zoomInTipLabel);
                zoomInLabel.append(_img);

                const zoomOutLabel = document.createElement("label");
                zoomOutLabel.setAttribute("class", "btn");
                _img = document.createElement('img');
                _img.setAttribute('src', this.assetsPathTheme('/map/zoom-minus.svg'));
                _img.setAttribute('alt', this.zoomOutTipLabel);
                zoomOutLabel.append(_img);

                let zoomClass = _map.getControlClassName(this.orderClassName);
                zoomClass = zoomClass.replace('ol-control', this.asGroup ? 'btn-group-vertical' : 'zoom-control');

                let panel = _map.getPanel(this.posBtnMap);
                if(panel) {
                    let ctrl = new Zoom({
                        target: panel.element,
                        className: zoomClass,
                        zoomInLabel: zoomInLabel,
                        zoomOutLabel: zoomOutLabel,
                    });
                    _map.addControlOL(ctrl);
                    return ctrl;
                }
                return false;
            },
        }

    }
</script>